import appConfig from "@/appConfig";
import $can      from "@/utils/abilities";

const moduleUserGetters = {
  id:                       state => state.id,
  token:                    state => state.token || null,
  permissions:              state => state.permissions || [],
  name:                     state => state.name,
  avatar:                   state => state.avatar ? appConfig.imgUrl + state.avatar : '',
  aparts:                   state => state.aparts.filter(apart => String(apart.account_number) !== String(state.account_number)),
  apart:                    state => state.aparts.find(apart => String(apart.account_number) === String(state.account_number)),
  allAparts:                state => state.aparts,
  publicid:                 state => {
    let apart = state.aparts.find(apart => String(apart.account_number) === String(state.account_number));
    return apart && apart.address[0].publicid ? apart.address[0].publicid : null;
  },
  apartment_id:             state => {
    let apart = state.aparts.find(apart => String(apart.account_number) === String(state.account_number));
    return apart && apart.id ? apart.id : null;
  },
  building_id:              state => {
    let apart = state.aparts.find(apart => String(apart.account_number) === String(state.account_number));
    return apart && apart.address[0].id ? apart.address[0].id : null;
  },
  sendChargeEmail:          state => {
    let apart = state.aparts.find(apart => String(apart.account_number) === String(state.account_number));
    return apart ? apart.send_charge_email : false;
  },
  account_number:           state => state.account_number,
  type:                     state => state.type_user,
  email:                    state => state.email,
  passport:                 state => state.passport,
  inn:                      state => state.inn,
  vk:                       state => state.vk,
  facebook:                 state => state.facebook,
  instagram:                state => state.instagram,
  management_companies_id:  state => state.management_companies_id,
  kvit:                     state => state.kvit,
  rash:                     state => state.rash,
  email_notifications:      state => state.email_notifications,
  devicesSettings:          state => state.devicesSettings,
  payments:                 state => state.payments,
  paymentTypes:             state => state.paymentTypes,
  deviceTypes:              state => state.device_types,
  deviceTypeById:           state => typeId => {
    let deviceType = state.device_types.find(deviceType => deviceType.id === typeId);
    return deviceType ? deviceType.name : 'Не известен';
  },
  houses:                   state => state.houses,
  housesGroups:             state => state.housesGroups,
  selectedHouse:            state => state.selectedHouse,
  selectedHouseId:          state => state.selectedHouse ? state.selectedHouse.id : null,
  selectedDate:             state => state.selectedDate,
  apartmentsTypes:          state => state.apartmentsTypes,
  availableApartmentsTypes: state => {
    let typesIds = state.selectedHouse.available_types;
    let globalTypes = state.apartmentsTypes;
    let available_types = [];
    if (typesIds) {
      typesIds = typesIds.split(',');
      if (typesIds.length >= 1) {
        typesIds.forEach(typeId => {
          let globalType = globalTypes.find(type => type.id === Number(typeId));
          if (globalType) {
            available_types.push(globalType);
          }
        });
      }
    }
    return available_types;
  },
  apartmentTypesByHouse:    state => house => {
    if (!house) return [];
    const apartmentTypes = state.apartmentsTypes;
    return house.available_types.split(',').reduce(( list, typeId ) => {
      const type = apartmentTypes.find(type => type.id === +typeId);
      if (type) list.push(type);
      return list;
    }, []);
  },
  housesByPermission:       ( state, getters ) => ( permission, rule = 'access' ) => {
    let houses = getters.houses;
    houses = houses.filter(h => $can(permission, rule, h.id));
    return houses;
  },

  groupedHouses: state => {
    const list = [];
    const fillGroups = ( group ) => {
      list.push({
        id:        group.id,
        title:     group.name,
        buildings: group.buildings.map((building => ({
          id:    building.id,
          title: `${building.street}, ${building.house}`,
        }))),
      });
      group.groups.forEach(fillGroups);
    };
    fillGroups(state.housesGroups);
    return list;
  },
};

export default moduleUserGetters;
